import { useSessionStorage } from '@vueuse/core';
import type { Algoliasearch } from 'algoliasearch';
import { algoliasearch, SettingsResponse } from 'algoliasearch';
import { liteClient, LiteClient } from 'algoliasearch/lite';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useAlgoliaSearchStore = defineStore(
  `algolia-search-${window.store_code}`,
  () => {
    const algoliaClient = ref<Algoliasearch>();
    const algoliaLiteClient = ref<LiteClient>();
    const settings = useSessionStorage<SettingsResponse | undefined>(
      'algolia-settings',
      undefined
    );

    const applicationId = window.application_id;
    const searchApiKey = window.search_api_key;

    function getAlgoliaClient() {
      if (!algoliaClient.value) {
        algoliaClient.value = algoliasearch(applicationId, searchApiKey);
      }

      return algoliaClient.value;
    }

    function getLiteClient() {
      if (!algoliaLiteClient.value) {
        algoliaLiteClient.value = liteClient(applicationId, searchApiKey);
      }

      return algoliaLiteClient.value;
    }

    async function getSettings(): Promise<SettingsResponse | undefined> {
      settings.value = await getAlgoliaClient().getSettings({
        indexName: window.product_index,
      });
      return settings.value;
    }

    return {
      getAlgoliaClient,
      getLiteClient,
      getSettings,
    };
  }
);
